// extracted by mini-css-extract-plugin
export default {"enrolling":"Enrolling_enrolling__zjIwX","text":"Enrolling_text__uXPBW"};